import { BenefitUse, BenefitUseFilters } from '@witkac/kartamiejska-shared';
import { BenefitUseResource, benefitUseResource } from '@witkac/kartamiejska-resources';

import { EntityModule } from './entity.module';

/**
 * Moduł używania usługi
 * @export
 * @class BenefitUsage
 */
export class BenefitsUsageModule extends EntityModule<BenefitUse, BenefitUseResource> {
  /**
   * Czy ma być używany namespace
   *
   * @type {boolean}
   */
  public namespaced: boolean = true;

  /**
   * Pola potrzebne do wyświetlenia listy
   *
   * @private
   * @memberof BenefitsUsageModule
   */
  private listFields = {
    id: true,
    created: true,
    price: true,
    value: true,
    place: {
      name: true,
      street: true,
      city: true,
      homeNumber: true,
      localNumber: true,
      partner: {
        id: true,
        name: true
      }
    },
    benefit: {
      name: true,
      type: true,
      value: true,
      partner: {
        id: true,
        name: true
      }
    }
  };

  constructor() {
    super(benefitUseResource);

    this.actions = {
      ...this.actions,

      /**
       * Pobiera listę encji
       *
       * @param context context
       * @param filters filtry listy
       */
      list: async (context: any, filters: BenefitUseFilters): Promise<void> => {
        const { list, count } = await this.resource.list(filters, false, this.listFields);
        context.commit('saveList', list);
        context.commit('saveCount', count);
      }
    };
  }
}

export default new BenefitsUsageModule();
